import React from "react";
import i18n from "i18next";
import "./UnreachableBadge.scss";

// Toolbar chip surfaced next to the items/triggers counter when the workflow
// has any nodes that no authored edge reaches from start. Clicking it
// dispatches a brief pulse highlight on the canvas (handled by the parent —
// this component is a pure presentational button).
//
// Renders nothing when `count` is 0 so the parent toolbar doesn't have to
// guard the mount itself. Keeps the call site `<UnreachableBadge count={n}
// onClick={...} />` no matter the workflow state.
//
// Color tokens: uses raw hex (matching `t.$danger` = #c5221f from the
// _studio-tokens palette) — the styles are scoped to this component so the
// chip is independent of any toolbar-level token sweeps that may rename the
// shared SCSS variables.
export default function UnreachableBadge({ count = 0, onClick }) {
  if (!count || count <= 0) return null;
  const handleClick = (e) => {
    if (typeof onClick === "function") onClick(e);
  };
  return (
    <button
      type="button"
      className="workflow-tab__unreachable"
      onClick={handleClick}
      title={i18n.t("Workflow.highlight_unreachable", {
        defaultValue: "Highlight unreachable nodes",
      })}
      data-testid="workflow-tab__unreachable-badge"
      aria-label={i18n.t("Workflow.unreachable_count", {
        defaultValue: "{{count}} unreachable nodes",
        count,
      })}
    >
      <i className="material-icons" aria-hidden="true">
        warning
      </i>
      <span className="workflow-tab__unreachable-count">{count}</span>
      <span className="workflow-tab__unreachable-label">
        {i18n.t("Workflow.unreachable", { defaultValue: "unreachable" })}
      </span>
    </button>
  );
}
